export default "__VITE_ASSET__yw6P0_FG__"